import { useQuery } from "@tanstack/react-query"
import type { TProject } from "@modules/project/workspace/types"
import { getProject } from "@modules/project/workspace/services"
import { useWorkspaceContext } from "@core/context"

const DEV_MOCK = false

export const projectKeys = {
  all: (workspaceId: string) => ["project", workspaceId] as const,
  detail: (workspaceId: string, projectId: string) =>
    ["project", workspaceId, projectId] as const,
}

export const useGetProject = (projectId: string) => {
  const { workspaceId } = useWorkspaceContext()
  return useQuery<TProject>({
    queryKey: projectKeys.detail(workspaceId, projectId),
    queryFn: ({ signal }) => {
      if (DEV_MOCK) return Promise.resolve({} as TProject)
      return getProject(workspaceId, projectId, signal)
    },
    enabled: !!projectId,
    staleTime: 2 * 60 * 1000,
    retry: 0,
  })
}
